import { createContext } from 'react';

export interface GovernanceTagsProcessingContextType {
  processingResources: Set<string>;
  addProcessingResource: (resourceId: string) => void;
  removeProcessingResource: (resourceId: string) => void;
  isResourceProcessing: (resourceId: string) => boolean;
  clearAllProcessing: () => void;
}

export const GovernanceTagsProcessingContext = createContext<GovernanceTagsProcessingContextType | undefined>(
  undefined,
);
